<template>
  <a-modal
    centered
    :title="title"
    v-model="visible"
    width="600px"
    :maskClosable="false"
    :destroyOnClose="true"
  >
    <a-table size="small" :pagination="false" rowKey="Id" :data-source="data">
      <a-table-column key="Name" title="名称" data-index="Name">
      </a-table-column>
      <a-table-column
        key="Quantity"
        title="数量"
        data-index="Quantity"
        width="130px"
        align="center"
      >
      </a-table-column>
    </a-table>
    <template #footer>
      <a-button @click="visible = false">关闭</a-button>
    </template>
  </a-modal>
</template>
<script>
export default {
  components: {},
  props: {
    title: {
      type: String,
      default: "查看套餐明细"
    },
    data: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      visible: true
    };
  },

  created() {},
  methods: {}
};
</script>

<style lang="less" scoped></style>
